import React from "react";
import { ShieldCheck, BadgeCheck } from "lucide-react";

/**
 * Google Guarantee Badge - shown to confirm verified Google Local Services status.
 * Two variants: 'compact' for headers/inline, 'full' for hero/footer/CTA areas.
 */
const GoogleGuaranteeBadge = ({ variant = "compact", className = "" }) => {
  if (variant === "full") {
    return (
      <div
        className={`inline-flex items-center gap-3 px-5 py-3 rounded-xl bg-white border-2 border-blue-600 shadow-md ${className}`}
        role="img"
        aria-label="Google Guaranteed - Decatur Solution Works is a Google Verified business"
      >
        <div className="h-11 w-11 rounded-lg bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700 flex items-center justify-center flex-shrink-0">
          <ShieldCheck className="h-6 w-6 text-white" strokeWidth={2.4} />
        </div>
        <div className="leading-tight">
          <div className="flex items-center gap-1.5">
            <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-blue-700">Google</span>
          </div>
          <div className="text-base font-extrabold text-slate-900 leading-none mt-0.5">Guaranteed</div>
          <div className="text-[10px] text-slate-500 mt-1 font-medium">Verified by Google</div>
        </div>
      </div>
    );
  }

  if (variant === "dark") {
    return (
      <div
        className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/10 border border-white/20 backdrop-blur ${className}`}
        role="img"
        aria-label="Google Guaranteed verified business"
      >
        <BadgeCheck className="h-4 w-4 text-green-400 flex-shrink-0" />
        <span className="text-[11px] font-bold uppercase tracking-wider text-white">
          <span className="text-blue-300">Google</span> Guaranteed
        </span>
      </div>
    );
  }

  // compact (default)
  return (
    <div
      className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-blue-50 border border-blue-200 ${className}`}
      role="img"
      aria-label="Google Guaranteed verified business"
    >
      <BadgeCheck className="h-3.5 w-3.5 text-blue-600 flex-shrink-0" />
      <span className="text-[11px] font-bold uppercase tracking-wider text-blue-700">
        Google Guaranteed
      </span>
    </div>
  );
};

export default GoogleGuaranteeBadge;
